import { Component } from '@angular/core';
import {NavController, ViewController} from "ionic-angular";
import {TranslateService} from "@ngx-translate/core";
import {MeetteamProvider} from "../../../../providers/meetteam/meetteam";

/**
 * Generated class for the CreateLunchComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'create-lunch',
  templateUrl: 'create-lunch.html'
})
export class CreateLunch {

  public localDate: Date = new Date();
  public initDate: Date = new Date();
  public min: Date = new Date();


  meetProps: any = {
    type: 0,
    multiple: false,
    date: null
  };

  createOutput : any = {
    created: false,
    match: false,
    id: '',
    coming: 0,
  };

  radioLabels = [
    this.translate.instant('lunchroulette.withonecollegue'),
    this.translate.instant('lunchroulette.withcollegues')
  ];

  radioChoice = 1;

  constructor(private navCtrl: NavController,
              private translate: TranslateService,
              private viewCtrl: ViewController,
              private meetProvider: MeetteamProvider) {

  }

  goBack() {
    this.viewCtrl.dismiss();
  }

  selectedDateFormat(e){
    this.meetProps.date = e.toLocaleDateString();
  }

  joinLunchRoulette(){
    if (this.meetProps.date == null) return;

    if (this.radioChoice === 2) this.meetProps.multiple = true;

    this.meetProvider.create(this.meetProps).subscribe((res) => {
      if(res.success){
        this.createOutput.created = true;
        this.createOutput.match = res.data.full;
        this.createOutput.id = res.data.id;
        this.createOutput.coming = res.data.count;

        this.goBack();
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/employee/lunchroulette/create-lunch/create-lunch.ts